export const generalQuestions = [
  {
    question: "What are the dates of the festival",
    answer: (
      <>
        We'll have programming the evening of July 17th into the late night, and we'll have programming at noon on July 118th into the late night. All campers must leave the venue by 3:30pm on July 119th.
      </>
    )
  },
  {
    question: "Where can I buy tickets?",
    answer: (
      <>
      Tickets are available at <a href="https://aftontickets.com/amplitude/" target="_blank" rel="noopener noreferrer">https://aftontickets.com/amplitude</a>. All tickets are hidden behind unlock codes. Want to receive a code? Reach out to the friend or channel who invited you to Amplitude.
      </>
    )
  },
  {
    question: "I don't see any tickets for sale, are they sold out?",
    answer: (
      <>
      All tickets are hidden behind unlock codes. Want to receive a code? Reach out to the friend or channel who invited you to Amplitude.
      </>
    )
  },
  {
    question: "Can I park near the venue and get a ride in?",
    answer: (
      <>
      Yes, with stipulations:
      <ol>
        <li>Ensure your campsite will have no more than 6 campers.</li>
        <li>Drive and legally park near the venue - reach out to us to get info on a $10/day + taxes lot 15 minutes from the venue.</li>
        <li>Get a ride from a campmate into the venue during gate hours.</li>
      </ol>
      </>
    )
  },
  {
    question: "Are tickets refundable?",
    answer: `Tickets are non-refundable.`,
  },
  {
    question: "What if I already purchased my ticket and am unable to attend?",
    answer: (
      <>
      Tickets can be transferred by following <a href="https://help.aftontickets.com/knowledgebase/how-to-transfer-a-ticket-to-a-friend/" target="_blank" rel="noopener noreferrer">these directions from our ticketing provider</a>. Please help us ensure a safe and enjoyable weekend for all attendees by ensuring ticket recipients are safe and welcoming individuals who understand consent, and will treat the venue with respect.
      </>
    )
  },
  {
    question: "How do I find a ride or offer a ride?",
    answer: (
      <>
      Attendees are organizing carpools in this <a href="https://docs.google.com/spreadsheets/d/1Cz1Dp_daE5VFUAizl5jYCggwFF17AMuoxJpC59d4Pog/edit?usp=sharing">Carpool Spreadsheet</a>.
      </>
    )
  },
  {
    question: "Tickets are too expensive - is there any other way for me to attend?",
    answer: (
      <>
      We don't want cost to be a barrier to attend. There are a couple of ways to minimize costs when attending Amplitude:
      <ul>
        <li>Carpool in a vehicle with up to 6 total people as there is only one Camping & Vehicle pass needed per vehicle.</li>
        <li>To further minimize the per-person cost you could park offsite (contact us for details on this), have a Camping & Vehicle pass holder pick you up, and camp with that pass holder for the duration of the festival. Note campsites can have a maximum of 6 people.</li>
        <li>During the ticket purchase process prospective attendees can sign up for a ticket installment plan through PayPal. </li>
      </ul>
      </>
    )
  },
  {
    question: "Are tickets refundable?",
    answer: `Tickets are non-refundable.`,
  },
  {
    question: "How much is camping/parking?",
    answer: (
      <>
         Camping & Vehicle passes range from $195 to $215.
      </>
    ),
  },
  {
    question: "How many people fit on a campsite?",
    answer: (
      <>
        Each Camping & Vehicle pass is allowed a maximum of one car and 6 people. Each campsite is 18' x 40', enough room for two 2-4 person tents and one vehicle.
      </>
    ),
  }
];

export const atTheFestQuestions = [
  {
    question: "Can I leave and then re-enter the festival?",
    answer: `Yes, once you have checked in and received your parking pass, you are free to go in and out of the festival grounds DURING GATE HOURS.`,
  },
  {
    question: "Are there quiet hours?",
    answer: `Yes, quiet hours are 4am-11am.`,
  },
  {
    question: "Are there food vendors?",
    answer: `No. Please remember to bring your own food.`,
  },
  {
    question: "Is grilling allowed?",
    answer: `Yes, we request that all BBQs be used on the gravel areas only. Do not use them on top of the grass or picnic tables.`,
  },
  {
    question: "Is there cell phone service?",
    answer: `Yes, there is typically cell phone service at the campgrounds.`,
  },
  {
    question: "Can I bring my kids or underage relatives/friends?",
    answer: `No. Amplitude is a 21+ event.`,
  },
  {
    question: "Are there showers on-site?",
    answer: `Yes. They will be available for a limited number of hours on Friday and Saturday. There is no additional charge to use the showers.`,
  },
  {
    question: "When are showers available?",
    answer: `Showers are available from 8:15pm - 10pm on Friday, and 1pm - 3pm on Saturday.`,
  },
  {
    question: "Is there ice available for purchase?",
    answer: `Yes, ice will be available for purchase from 7 - 8pm on Friday then 11am - 12pm, 5pm - 6pm, 7 - 8pm on Saturday. It will cost $10 via cash or $13 via Venmo.`,
  },
  {
    question: "Are there RV hook-ups?",
    answer: `No.`,
  },
  {
    question:
      "Can I stay at a hotel nearby the venue and come visit during gate hours?",
    answer: `We strongly discourage doing this. You will still need to pay for a Camping & Vehicle Pass to enter the gates and park your car, and your vehicle will only be able to enter/exit during gate hours.`,
  }
];

export const otherQuestions = [
  {
    question:
      "How do I reach out if I have other questions?",
    answer: (
      <>
        Send an email to info@amplitudefestival.com.
      </>
    ),
  }
];
